var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchedSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#D9622A",
    stroke: "#D9622A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11157_340347",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1279 28.8474L28.1852 15.8279L15.1657 2.77071L2.10845 15.7902L15.1279 28.8474Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.75
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11157_340347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1832 14.4824C15.9758 14.4698 15.778 14.5048 15.5994 14.5774C15.3847 14.6647 15.1505 14.5037 15.1508 14.272L15.1533 12.5499C15.1544 11.8047 14.5512 11.1998 13.8061 11.1987L12.084 11.1962C11.8522 11.1959 11.6919 10.9611 11.7798 10.7467C11.853 10.5684 11.8885 10.3707 11.8765 10.1633C11.8382 9.50089 11.3049 8.96026 10.643 8.91375C9.8648 8.85903 9.21592 9.47359 9.21479 10.2404C9.21456 10.4173 9.24884 10.5862 9.31127 10.7407C9.39857 10.9566 9.23978 11.1921 9.00688 11.1917L7.28477 11.1893C6.53961 11.1882 5.93466 11.7914 5.93359 12.5365L5.93113 14.2546C5.93077 14.4853 6.16311 14.6466 6.37726 14.561C6.55569 14.4898 6.75312 14.456 6.95981 14.4694C7.61961 14.5123 8.1553 15.0462 8.19985 15.7059C8.25242 16.4844 7.63596 17.1316 6.86909 17.1305C6.69519 17.1302 6.52915 17.0967 6.37696 17.0358C6.16142 16.9497 5.927 17.1075 5.92666 17.3396L5.92417 19.0578C5.92307 19.8029 6.52627 20.4079 7.27143 20.409L8.98957 20.4114C9.22018 20.4118 9.38151 20.1795 9.29596 19.9653C9.22469 19.7869 9.19092 19.5895 9.20434 19.3828C9.24714 18.723 9.78112 18.1873 10.4408 18.1427C11.2193 18.0901 11.8665 18.7066 11.8654 19.4735C11.8651 19.6474 11.8316 19.8134 11.7708 19.9656C11.6846 20.1812 11.8424 20.4156 12.0745 20.4159L13.7927 20.4184C14.5379 20.4195 15.1428 19.8163 15.1439 19.0711L15.1464 17.349C15.1467 17.1161 15.3827 16.958 15.5983 17.0459C15.7526 17.1088 15.9214 17.1436 16.0983 17.1438C16.8651 17.145 17.4815 16.4978 17.4291 15.7195C17.3845 15.0575 16.8454 14.5226 16.1832 14.4824Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3403 20.428L21.2896 20.4265C21.0579 20.4262 20.8969 20.6604 20.9841 20.8751C21.0567 21.0536 21.0917 21.2515 21.0791 21.4588C21.0389 22.1211 20.504 22.6602 19.842 22.7048C19.0637 22.7572 18.4166 22.1408 18.4177 21.374C18.4179 21.1971 18.4527 21.0283 18.5156 20.874C18.6035 20.6583 18.4454 20.4224 18.2125 20.4221L16.4904 20.4196C15.7452 20.4185 15.142 19.8135 15.1431 19.0684",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.154 12.5508C15.1551 11.8057 15.7601 11.2025 16.5052 11.2036L18.2234 11.206C18.454 11.2064 18.6146 11.4392 18.5285 11.6531C18.4567 11.8313 18.4223 12.0286 18.4351 12.2353C18.4761 12.8953 19.0084 13.4325 19.668 13.479C20.4463 13.5338 21.0954 12.9192 21.0965 12.1523C21.0967 11.9784 21.0636 11.8123 21.0033 11.66C20.9177 11.4442 21.0762 11.2102 21.3083 11.2105L23.0265 11.213C23.7716 11.2141 24.3748 11.819 24.3737 12.5642L24.3713 14.2863C24.3709 14.5192 24.6064 14.678 24.8223 14.5907C24.9768 14.5282 25.1457 14.494 25.3226 14.4942C26.0894 14.4953 26.704 15.1442 26.6492 15.9224C26.6027 16.5843 26.0621 17.1176 25.3997 17.1559C25.1924 17.1679 24.9946 17.1324 24.8163 17.0592C24.6018 16.9713 24.3671 17.1316 24.3668 17.3634L24.3654 18.3785",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchedSelected);
export default __webpack_public_path__ + "static/media/matched-selected.74e98136cada415801dc05e3853364eb.svg";
export { ForwardRef as ReactComponent };